import React, { Component } from "react";
import FlatButton from 'material-ui/FlatButton';
import ErrorIcon from 'material-ui/svg-icons/alert/error';
import { DebugEx } from "../../Utils/DebugEx";
import { ErrorBoundary } from "@sentry/react";
// ------------------------------------------------------------------------------------------------
export interface ErrorCatchProps {

}
// ------------------------------------------------------------------------------------------------
interface ErrorCatchState {
    hasError: boolean;
}
// ------------------------------------------------------------------------------------------------
export class ErrorCatch extends Component<ErrorCatchProps, ErrorCatchState>{
    constructor(props) {
        super(props);
        this.state = {
            hasError: false
        };
    }
    // ------------------------------------------------------------------------------------------------
    componentDidCatch(error, info) {
        DebugEx.TraceException(error, info);
        // Display fallback UI
        this.setState({ hasError: true });
    }
    // --------------------------------------------------------------------------------------------
    render() {
        if (this.state.hasError)
            return <div
                style={{
                    width: "100%", height: "100%",
                    textAlign: 'center',
                    fontSize: 'medium',
                    fontWeight: 700,
                    backgroundColor: "#e5e3df",
                    color: "#757575",
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex"
                }}>
                <div>
                    <ErrorIcon style={{ width: 32, height: 32, color: "#757575" }} />
                    <p>{"Oops! Something went wrong."}</p>
                    <FlatButton
                        labelStyle={{ fontSize: 12 }}
                        label={"Reset widget"}
                        onClick={() => this.setState({ hasError: false })}
                    />
                </div>
            </div>;

        return this.props.children;
    }
}
// ------------------------------------------------------------------------------------------------

export function ErrorCatchv2(props: { children: React.ReactNode }) {
    return <ErrorBoundary
        fallback={({ error, componentStack, resetError }) => (
            <div
                style={{
                    width: "100%", height: "100%",
                    textAlign: 'center',
                    fontSize: 'medium',
                    fontWeight: 700,
                    backgroundColor: "#e5e3df",
                    color: "#757575",
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex"
                }}>
                <div>
                    <ErrorIcon style={{ width: 32, height: 32, color: "#757575" }} />
                    <p>{"Oops! Something went wrong."}</p>
                    <FlatButton
                        labelStyle={{ fontSize: 12 }}
                        label={"Reset widget"}
                        onClick={resetError}
                    />
                </div>
            </div>
        )}
    >
        {props.children}
    </ErrorBoundary>
}


// ------------------------------------------------------------------------------------------------